import { Link } from 'react-router-dom';
import logo from '../assets/Best_National_Carports-logo-blk.svg';
import PublicFooter from '../components/PublicFooter';

export default function Support() {
	const lastUpdated = 'June 9, 2026';

	return (
		<div className="support-page min-h-screen bg-white text-slate-800">
			<header className="border-b border-slate-200">
				<div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
					<Link to="/" className="inline-flex">
						<img
							src={logo}
							alt="Best National Carports Logo"
							className="h-10 w-auto"
						/>
					</Link>
					<Link to="/" className="text-sm text-blue-600 underline">
						Back to Login
					</Link>
				</div>
			</header>
			<main className="max-w-3xl mx-auto px-6 py-12">
				<h1 className="text-3xl font-semibold text-black mb-2">Support</h1>
				<p className="text-sm text-slate-500 mb-10">
					Last updated: {lastUpdated}
				</p>

				<section className="space-y-4 mb-8">
					<p>
						Welcome to the Best National Carports support page. We&rsquo;re here
						to help you get the most out of our mobile application and related
						services. If you have questions, run into a problem, or need
						assistance with your account, please reach out using the contact
						details below.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Getting Help</h2>
					<p>
						For the fastest assistance, please email our support team with a
						description of your issue, the device and operating system you are
						using, and any relevant screenshots. We aim to respond to all
						inquiries within two business days.
					</p>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Common Topics</h2>
					<ul className="list-disc pl-6 space-y-2">
						<li>Account access, login, and password assistance</li>
						<li>Reporting a bug or unexpected behavior in the app</li>
						<li>Questions about features and how to use them</li>
						<li>Requests to update or delete your information</li>
						<li>General feedback and suggestions</li>
					</ul>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Contact Us</h2>
					<p>
						Support for this application is provided by Web Design Pilot LLC. You
						can reach us at:
					</p>
					<ul className="space-y-1">
						<li>
							<span className="font-medium">Company:</span> Web Design Pilot LLC
						</li>
						<li>
							<span className="font-medium">Email:</span>{' '}
							<a
								href="mailto:support@webdesignpilot.com"
								className="text-blue-600 underline"
							>
								support@webdesignpilot.com
							</a>
						</li>
						<li>
							<span className="font-medium">Website:</span>{' '}
							<a
								href="https://www.webdesignpilot.com"
								target="_blank"
								rel="noopener noreferrer"
								className="text-blue-600 underline"
							>
								www.webdesignpilot.com
							</a>
						</li>
					</ul>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">
						Delete Your Account
					</h2>
					<p>
						You may request the deletion of your account and associated personal
						data at any time. Once we receive and verify your request, we will
						permanently delete your account and any data we are not required to
						retain for legal or accounting purposes. This action cannot be
						undone.
					</p>
					<p>
						To submit a deletion request, click the button below and send us the
						pre-filled email from the address associated with your account. We
						will process your request within 30 days.
					</p>
					<a
						href="mailto:support@webdesignpilot.com?subject=Account%20Deletion%20Request&body=I%20would%20like%20to%20request%20the%20permanent%20deletion%20of%20my%20account%20and%20associated%20data.%0A%0AAccount%20email%3A%20%0AFull%20name%3A%20"
						className="inline-block rounded-md bg-red-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-red-700"
					>
						Request Account Deletion
					</a>
				</section>

				<section className="space-y-3 mb-8">
					<h2 className="text-xl font-semibold text-black">Privacy</h2>
					<p>
						To learn how we handle your information, please review our{' '}
						<Link to="/privacy" className="text-blue-600 underline">
							Privacy Policy
						</Link>
						.
					</p>
				</section>
			</main>
			<PublicFooter />
		</div>
	);
}
